import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-1-icon',
  templateUrl: './ac-type-1-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcType1IconComponent {}
